import { render, staticRenderFns } from "./tiDialog.vue?vue&type=template&id=7b82b9b5&scoped=true"
import script from "./tiDialog.vue?vue&type=script&lang=js"
export * from "./tiDialog.vue?vue&type=script&lang=js"
import style0 from "./tiDialog.vue?vue&type=style&index=0&id=7b82b9b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b82b9b5",
  null
  
)

export default component.exports